import { Grid, Typography, GridProps, SxProps } from '@mui/material';
import { Img } from '@/components/blocks/MaterialImage';
import { Linkable } from '@/components/blocks/Linkable';
import { combineSX } from '@/utils/combineSX';

type DpGridCardProps = GridProps & {
	href?: string;
	img: string;
	title?: string;
	subtitle?: string;
	xsimg?: SxProps;
	xstitle?: SxProps;
	xssubtitle?: SxProps;
	alt?: string;
	variant?: string;
	loading?: 'lazy' | 'eager';
	priority?: boolean;
};

// eslint-disable-next-line complexity
export const DpGridCard = ({
	href,
	img,
	title,
	subtitle,
	xsimg,
	xstitle,
	xssubtitle,
	alt,
	variant,
	loading,
	priority,
	...props
}: DpGridCardProps) => (
	<Grid item xs={12} md={3} sm={variant ? 12 : 6} {...props}>
		<Linkable type="link" href={href}>
			<Img
				src={img}
				alt={alt ?? title}
				sx={combineSX([
					{
						objectFit: 'cover',
						width: variant === 'scroll' ? '' : '100%',
						minWidth: variant === 'scroll' ? '309px' : '',
						height: { xs: 'auto', md: '362px' },
					},
					...(Array.isArray(xsimg) ? xsimg : [xsimg]),
				])}
				loading={loading}
				priority={priority}
			/>
			{title ? (
				<Typography
					component={'h3'}
					dp-button-whats-app
					sx={combineSX([
						{
							fontSize: {
								xs: 'var(--font-size-sm)',
								sm: 'var(--font-size-md)',
							},
							fontWeight: {
								xs: '900',
								sm: 'bold',
							},
							color: 'text.primary',
							textAlign: {
								xs: variant === 'scroll' ? 'start' : 'center',
								sm: 'start',
							},
						},
						...(Array.isArray(xstitle) ? xstitle : [xstitle]),
					])}
				>
					{title}
				</Typography>
			) : null}
			{subtitle ? (
				<Typography
					sx={combineSX([
						{
							fontWeight: 'normal',
							color: 'text.primary',
							fontSize: 'var(--font-size-body)',
							textAlign: {
								xs: variant === 'scroll' ? 'start' : 'center',
								sm: 'start',
							},
						},
						...(Array.isArray(xssubtitle) ? xssubtitle : [xssubtitle]),
					])}
				>
					{subtitle}
				</Typography>
			) : null}
		</Linkable>
	</Grid>
);

export const DpGridCards = ({ children, ...props }: GridProps) => (
	<Grid container spacing="20px" {...props}>
		{children}
	</Grid>
);
